import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StateStorageService {
    public static $name = 'stateStorageService';
    private _state: any;

    public getState(): any {
        const state = this._state;
        this._state = null;

        return state;
    }

    public setState(state: any) {
        this._state = state;
    }
}
